export default __webpack_public_path__ + "static/media/Zambia.bb2a7485.png";